import * as yup from 'yup'

const schema = yup.object().shape({
  idAnimal: yup.string().required('Selecione a vaca'),
  dataParto: yup.string().required('Informe a data do parto'),
  tipoParto: yup.string().required('Selecione o tipo de parto'),
  tipoReproducao: yup.string().required('Selecione o tipo de reprodução'),
  touro: yup.string().required('Selecione o touro')
})

export default schema
